import { BasicPage, RouteSlotInput } from '@luks/ui';

import { removeEmptyParagraphs } from '../commons/preprocess-paragraphs';
import { mapParagraphs } from './paragraphs/AllParagraphs';

export function mapSidebar(
  input: BasicPageFragment['sidebar'],
): RouteSlotInput<
  typeof BasicPage,
  'body',
  'Sidebar' | 'ContextualTextSection'
> {
  const paragraphs = removeEmptyParagraphs(input);
  return {
    key: 'Sidebar',
    input: {
      content: {
        items: mapParagraphs(paragraphs, { inSidebar: true }),
      },
    },
  };
}
